import { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import "./HowToPlay.scss";
import { useTranslation } from "react-i18next";
import BackgroundKO from "../../images/game-explain-bg.png";
import BackgroundEN from "../../images/game-explain-bg-en.png";

const HowToPlay = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      className="howtoplay-main-root"
      style={{ backgroundImage: `url(${t("lang") === "en" ? BackgroundEN : BackgroundKO})` }}
    >
      <div className="howtoplay-title">{t("howtoplay")}</div>
      <div className="howtoplay-explain">{t("howtoplay-explain")}</div>
      <div className="content">
        <div className="title">{t("howtoplay-title1")}</div>
        <div className="explain">{t("howtoplay-explain1")}</div>
      </div>
      <div className="content">
        <div className="title">{t("howtoplay-title2")}</div>
        <div className="explain">{t("howtoplay-explain2")}</div>
      </div>
      <div className="content content-last">
        <div className="title">{t("howtoplay-title3")}</div>
        <div className="explain">
          {t("howtoplay-explain3-1")}
          <span>{t("howtoplay-explain3-2")}</span>
          {t("howtoplay-explain3-3")}
        </div>
      </div>
      <div className="button-wrap">
        <button
          className="start-button"
          onClick={() => {
            navigate("/selectgoal");
          }}
        >
          {t("play2")}
        </button>
      </div>
    </div>
  );
};

export default HowToPlay;
